import { Box, Skeleton, SxProps, Theme } from '@mui/material';

// Placeholder shown while an existing session's saved messages load — alternating coach
// text and a user bubble so it reads as a conversation filling in.
export const ChatSkeleton = () => (
  <Box id="chat-loading-skeleton" sx={containerSx} aria-hidden>
    <CoachLines widths={['92%', '68%']} />
    <UserBubble />
    <CoachLines widths={['88%', '60%']} />
  </Box>
);

const CoachLines = ({ widths }: { widths: [string, string] }) => (
  <Box sx={coachGroupSx}>
    {widths.map((width, index) => (
      <Skeleton key={index} variant="text" animation="wave" width={width} />
    ))}
  </Box>
);

const UserBubble = () => (
  <Box sx={userBubbleSx}>
    <Skeleton variant="text" animation="wave" width="100%" />
    <Skeleton variant="text" animation="wave" width="70%" />
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: backrs.spacing['spacing-xl'],
});

const coachGroupSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-start',
  width: '78%',
};

const userBubbleSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-end',
  width: '55%',
  padding: `${backrs.spacing['spacing-md']} ${backrs.spacing['spacing-lg']}`,
  backgroundColor: backrs.colors['Gray/100'],
  borderRadius: `${backrs.radius['radius-md']} 0 ${backrs.radius['radius-md']} ${backrs.radius['radius-md']}`,
});
